export default __webpack_public_path__ + "static/google-play_download_it-27ac9e392bc9db5ce232fce7976cef66.png";